var map = {
	"./1_seed.svg": 5080,
	"./2_sprout.svg": 8279,
	"./3_smol.svg": 7929,
	"./4_grown.svg": 9279,
	"./5_budding.svg": 6705,
	"./6_bearing.svg": 2096,
	"./focus-bg.jpg": 6622,
	"./logo.png": 4427,
	"./logo.svg": 2835,
	"./snail_loader.gif": 3641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;